.container {
  display: flex;
  align-items: center;
}
